import Rolling from '@assets/gif/loadingTwo.gif';

import { Container, Logo, LoadingImg2 } from './Loading.styles';

const Loading = () => {
  return (
    <Container>
      <Logo width={100} />

      {/* Maybe */}
      {/* <LoadingImg className="reset-global" /> */}
      <LoadingImg2 src={Rolling} />
    </Container>
  );
};

export { Loading };
